import { uuid } from 'vue-uuid';
import {
  GET_MENU_ITEMS,
  SET_SELECTED_FOLDER,
  SET_SELECTED_TABLE,
  SET_SELECTED_MODULE,
  GET_MODULE_INFO,
  SET_SELECTED_MODULE_NAME,
  SET_LOADING_STATE,
  SET_MODULE_CONFIGURATION,
  SET_TABLE_LIST,
  SET_FOLDERS_LIST_WITH_EXCEPTIONS,
  ADD_TAG_TO_TAGS_LIST,
  UPDATE_TAGS_LIST,
  REMOVE_TAG_FROM_TAGS_LIST,
} from './mutation-types';
import {axiosClient} from '@/core/services/http.service';

const systemPathsNames = {
  'Mdm Model': '/app/mdm-model',
  'To Do List': '/app/todolist',
  'Connectors': '/app/connector-screen',
  'Loan Calculator': '/app/loan-calculator',
  'Sun Model': '/app/sunmodel',
  'Orchestration': '/app/orchestration',
  'File Logs': '/monitoring/file-logs',
  'Job Queue': '/monitoring/job-queue', // Add the path for the Job Queue module
  'FTP Storage List': '/file-manipulation/storage-list',
  'Batch File': '/file-manipulation/batch-file',
  'Batch Endpoint': '/file-manipulation/batch-endpoint',
  'User Security': '/administration/users',
  'Audit Log': '/administration/audit-log',
  'System Settings': '/administration/system-settings',
  'Global Permissions': '/administration/global',
  'Custom navigation': '/administration/custom-navigation',
};
const administrationTemplate = {
  children: [],
  currentUserPermissionLevel: 'admin',
  description: '',
  icon: ['fas', 'info-circle'],
  isOpen: false,
  isSystem: true,
  isSelected: false,
  label: 'Administration',
  folderGuid: '1',
  moduleGuid: '1',
  type: 'module',
};

const monitoringTemplate = {
  children: [],
  currentUserPermissionLevel: 'admin',
  description: '',
  icon: ['fas', 'chart-bar'],
  isOpen: false,
  isSystem: true,
  isSelected: false,
  label: 'Monitoring',
  folderGuid: '2',
  moduleGuid: '2',
  type: 'module',
};

const fileManipulationTemplate = {
  children: [],
  currentUserPermissionLevel: 'admin',
  description: '',
  icon: ['fas', 'file'],
  isOpen: false,
  isSystem: true,
  isSelected: false,
  label: 'File Manipulation',
  folderGuid: '3',
  moduleGuid: '3',
  type: 'module',
};

const administration = {'User Security': 0, 'Audit Log': 1, 'System Settings': 2, 'Global Permissions': 3, 'Custom navigation': 4};
const fileManipulation = {'FTP Storage List': 0, 'Batch File': 1, 'Batch Endpoint': 2};
const monitoringItems = {'File Logs': 0, 'Job Queue': 1};

const isSubModule = (type) => {
  return type === 'sub-module';
};

export const transformData = (data, isValueExist = false, foldersExceptions, tableExceptions) => {
  return data.reduce((acc, item) => {

    const doneElement = {
      ...item,
      isSelected: false,
      isOpen: false,
    };
    if (item.isSystem) {
      if ('children' in item) {
        item.children = item.children.map(folder => {
          if ('children' in folder) {
            folder.children = folder.children.map(entity => {
              const isPowerApp = JSON.parse(entity.entityConfig).EntityType === 'powerApp';
              const isPowerBiReport = JSON.parse(entity.entityConfig).EntityType === 'powerBiReport';
              const view = isPowerApp
                ? 'power-apps-table'
                : isPowerBiReport
                  ? 'power-bi-report'
                  : 'table';
              return {
                ...entity,
                icon: entity.icon || ['fas', 'table'],
                isSelected: false,
                type: 'table',
                path: `/app/all-modules/${entity.moduleGuid}/${view}/${entity.entityGuid}?moduleUuid=${item.moduleGuid}`,
              };
            });
          }
          return {
            ...folder,
            icon: folder.icon || ['fas', 'folder'],
            type: 'folder',
            isSelected: false,
            path: isSubModule(folder.type) ? folder.path : null,
          };
        });
      }
      const element = {
        ...item,
        type: 'module',
        isSelected: false,
        icon: doneElement.icon || ['fas', 'puzzle-piece'],
        path: item.label !== fileManipulationTemplate.label
                    && item.label !== administrationTemplate.label
                    && item.label !== monitoringTemplate.label
                    && `${systemPathsNames[item.label]}`,
      };
      acc.systems.push(element);
    } else {
      if ('children' in item) {
        const filteredChildren = item.children.filter(el => (
          !['none', 'deny'].includes(el.currentUserPermissionLevel)
                    || (el.folderGuid in foldersExceptions)
        ));
        if (filteredChildren.length === 1 && !isValueExist) {
          item.children = 'children' in filteredChildren[0] && filteredChildren[0].children
            .filter(el => !['none', 'deny'].includes(el.currentUserPermissionLevel))
            .map(entity => {
              const isPowerApp = JSON.parse(entity.entityConfig).EntityType === 'powerApp';
              const isPowerBiReport = JSON.parse(entity.entityConfig).EntityType === 'powerBiReport';
              const view = isPowerApp
                ? 'power-apps-table'
                : isPowerBiReport
                  ? 'power-bi-report'
                  : 'table';
              return {
                ...entity,
                type: 'table',
                isSelected: false,
                icon: entity.icon || ['fas', 'table'],
                path: `/app/all-modules/${entity.moduleGuid}/${view}/${entity.entityGuid}?moduleUuid=${item.moduleGuid}`,
              };
            });
        } else {
          item.children = filteredChildren
            .map(folder => {
              if ('children' in folder) {
                folder.children = folder.children
                  .filter(el => !['none', 'deny'].includes(el.currentUserPermissionLevel))
                  .map(entity => {
                    const isPowerApp = JSON.parse(entity.entityConfig).EntityType === 'powerApp';
                    const isPowerBiReport = JSON.parse(entity.entityConfig).EntityType === 'powerBiReport';
                    const view = isPowerApp
                      ? 'power-apps-table'
                      : isPowerBiReport
                        ? 'power-bi-report'
                        : 'table';
                    return {
                      ...entity,
                      type: 'table',
                      isSelected: false,
                      icon: entity.icon || ['fas', 'table'],
                      path: `/app/all-modules/${entity.moduleGuid}/${view}/${entity.entityGuid}?module_uuid=${item.moduleGuid}`,
                    };
                  });
              }
              return {
                ...folder,
                type: 'folder',
                isSelected: false,
                icon: folder.icon || ['fas', 'folder'],
                path: `/app/all-modules/${folder.moduleGuid}`,
              };
            });
        }
      }
      acc.noSystems.push({
        ...item,
        type: 'module',
        icon: item.icon || ['fas', 'puzzle-piece'],
        path: `/app/all-modules/${item.moduleGuid}`,
      });
    }
    acc.systems.sort((a) => a.children.length && a.label !== 'Loan Calculator' ? 1 : -1);
    acc.noSystems.sort((a, b) => a.children.length && a.sortOrder - b.sortOrder);
    return acc;
  }, {
    general: [
      {
        label: 'Module Configuration',
        type: 'module',
        icon: ['fas', 'puzzle-piece'],
        path: '/app/all-modules',
      },
    ],
    systems: [],
    noSystems: [],
  });
};
export const getSidebarStructure = async ({commit, rootState}) => {
  administrationTemplate.children = [];
  const isUser = rootState.user.currentUserAdpPermission.data.role === 'user';
  const {body, success} = await axiosClient.get('/api/module/structure');

  const transform = body.map(module => {
    if (!['none', 'deny'].includes(module.currentUserPermissionLevel)) {
      return module;
    }
    if (module.children.length && ['none', 'deny'].includes(module.currentUserPermissionLevel)) {
      let folderWithDifferentRights = {};
      let tablesWithDifferentRights = {};
      module.children.forEach(folder => {
        if (!['none', 'deny'].includes(folder.currentUserPermissionLevel)) {
          folderWithDifferentRights[folder.folderGuid] = folder;
        }
        if (folder.children.length && ['none', 'deny'].includes(folder.currentUserPermissionLevel)) {
          folder.children.forEach(table => {
            const isVisibleTableExist = folder.children.some(el => !['none', 'deny'].includes(el.currentUserPermissionLevel));
            if (!['none', 'deny'].includes(table.currentUserPermissionLevel) || isVisibleTableExist) {
              if (!(folder.folderGuid in folderWithDifferentRights)) {
                folderWithDifferentRights[folder.folderGuid] = {
                  ...folder,
                  currentUserPermissionLevel: 'read',
                };
                commit(SET_FOLDERS_LIST_WITH_EXCEPTIONS, folderWithDifferentRights);
              }
              tablesWithDifferentRights[table.entityGuid] = table;
            }
          });
        }
        if (tablesWithDifferentRights.length) {
          folder.children = Object.values(tablesWithDifferentRights);
        }
      });
      if (folderWithDifferentRights.length) {
        commit(SET_FOLDERS_LIST_WITH_EXCEPTIONS, folderWithDifferentRights);
        module.children = Object.values(folderWithDifferentRights);
      }
      if (
        !Object.values(folderWithDifferentRights).length
                && !Object.values(tablesWithDifferentRights).length
                && ['none', 'deny'].includes(module.currentUserPermissionLevel)
      ) {
        return;
      }
      folderWithDifferentRights = {};
      tablesWithDifferentRights = {};
      return module;
    }
  }).filter(el => !!el);

  if (success) {
    const res = transform.reduce((acc, el) => {
      const itemTemplate = {
        type: 'sub-module',
        isSelected: false,
        icon: el.icon || ['fas', 'puzzle-piece'],
        path: `${systemPathsNames[el.label]}`,
      };
      if (el.label in administration) {
        const alreadyExists = administrationTemplate.children.some(
          (child) => child.label === el.label,
        );
        if(!alreadyExists){
          administrationTemplate.children.push({
            ...el,
            ...itemTemplate,
            folderGuid: administrationTemplate.folderGuid,
          });
        }
      } else if (el.label in fileManipulation) {
        const alreadyExists = fileManipulationTemplate.children.some(
          (child) => child.label === el.label,
        );
        if(!alreadyExists){
          fileManipulationTemplate.children.push({
            ...el,
            ...itemTemplate,
            folderGuid: fileManipulationTemplate.folderGuid,
          });
        }
      } else if (el.label in monitoringItems) {
        const alreadyExists = monitoringTemplate.children.some(
          (child) => child.label === el.label,
        );
        if(!alreadyExists){
          monitoringTemplate.children.push({
            ...el,
            ...itemTemplate,
            folderGuid: monitoringTemplate.folderGuid,
          });
        }
      } else {
        acc.push(el);
      }
      return acc;
    }, []);
    const customNav = {
      children: [],
      currentUserPermissionLevel: 'admin',
      description: '',
      folderGuid: '1',
      icon: 'edit',
      isActive: true,
      isSelected: false,
      isSystem: true,
      label: 'Custom Navigation',
      moduleGuid: uuid.v4(),
      path: '/administration/custom-navigation',
      schemaName: 'mdm_system_customNavigation',
      sortOrder: 111,
      type:'sub-module',
    };
    if(rootState.app.isFourthVersion){
      administrationTemplate.children.push(customNav);
    }
    !!administrationTemplate.children.length && res.push(administrationTemplate);
    !!fileManipulationTemplate.children.length && res.push(fileManipulationTemplate);
    !!monitoringTemplate.children.length && res.push(monitoringTemplate);
 
    commit(GET_MENU_ITEMS, res);

    const mdmForTables = [];
    const map = {
      system: {
        children: [],
        label: 'System Modules',
        icon: null,
      },
      mdm: {
        children: [],
        label: 'MDM Modules',
        icon: null,
      },
    };
    body.forEach(el => {
      mdmForTables.push(el);
      map[el.isSystem ? 'system' : 'mdm'].children.push(
        el.isSystem
          ? {...el, path: `${systemPathsNames[el.label]}`}
          : el,
      );
    });

    map.mdm.children = transform
      .filter(el => !el.isSystem)
      .sort((a, b) => a.sortOrder - b.sortOrder);

    const tables = {};
    const modules = {};
    const folders = {};
    mdmForTables.forEach(module => {
      module.isLoading = false;
      if (!module.isSystem) {
        modules[module.moduleGuid] = module;
      }
      if (module.children.length) {
        module.children
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .forEach(folder => {
            folder.isLoading = false;
            folders[folder.folderGuid] = folder;
            if (folder.children.length) {
              folder.children
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .forEach(table => {
                  table.isLoading = false;
                  tables[table.entityGuid] = table;
                });
            }
          });
      }
    });
    map.system.children = map.system.children.filter(el => !['none', 'deny'].includes(el.currentUserPermissionLevel));
    commit(SET_TABLE_LIST, {modules, folders, tables});
    commit(SET_MODULE_CONFIGURATION, Object.values(map));
  }
};

export const getModuleDetails = async ({commit}, moduleUuid) => {
  commit(GET_MODULE_INFO, null);
  commit(SET_LOADING_STATE, true);
  const {body, success} = await axiosClient.get(`/api/folder/structure/${moduleUuid}`);
  if (success) {
    const sortedBody = body.map(el => {
      if (el.children.length) {
        return {
          ...el,
          children: el.children.sort((a, b) => a.sortOrder - b.sortOrder),
        } ;
      }
      return el;
    }).sort((a, b) => a.sortOrder - b.sortOrder);
    commit(GET_MODULE_INFO, sortedBody);
  }
  commit(SET_LOADING_STATE, false);
};

export const setSelectedModuleAction = ({commit}, uuid) => {
  commit(SET_SELECTED_MODULE, uuid);
};
export const setSelectedFolderAction = ({commit}, item) => {
  commit(SET_SELECTED_FOLDER, item);
};
export const setSelectedTableAction = ({commit}, item) => {
  commit(SET_SELECTED_TABLE, item);
};
export const setSelectedModuleName = ({commit}, name) => {
  commit(SET_SELECTED_MODULE_NAME, name);
};
export const addTagToTagsList = ({commit}, payload) => {
  commit(ADD_TAG_TO_TAGS_LIST, payload);
};
export const updateTagsList = ({commit}, payload) => {
  commit(UPDATE_TAGS_LIST, payload);
};
export const removeTagFromTagsList = ({commit}, payload) => {
  commit(REMOVE_TAG_FROM_TAGS_LIST, payload);
};

export const updateModuleSortOrder = async ({state, commit, rootState}) => {
  const finalPayload =  state.moduleConfiguration[1].children.map( (el, idx) => ({
    id: el.moduleGuid,
    sortOrder: idx,
  }));
  const {success} = await axiosClient.post('api/module/updatesortorders', finalPayload);
  if(success){
    await getSidebarStructure({commit, rootState});
  }
  return success;
};

export const updateFolderSortOrder = async ({ state, commit, rootState}) => {
  const finalPayload =  state.moduleInfo.map((el, idx) => ({
    id: el.folderGuid,
    sortOrder: idx,
  }));
  const {success} = await axiosClient.post('api/folder/updatesortorders', finalPayload);
  if(success){
    await getSidebarStructure({commit, rootState});
  }
  return success;

};
export const updateTableSortOrder = async ({state, commit, rootState}, payload) => {
  const finalPayload =  payload.children.map( (el, idx) => ({
    id: el.entityGuid,
    sortOrder: idx,
  }));
  const {success} = await axiosClient.post('api/entity/updatesortorders', finalPayload);
  if(success){
    await getSidebarStructure({commit, rootState});
  }
  return success;
};